package com.milta.core.localization.translations.pl

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Import — Zdjęcie",
    titlePdf = "Import — PDF",
    titleSpreadsheet = "Import — Excel / CSV",
    fileSentSuffix = "wysłano przed chwilą",
    fileWaitingConnectionLabel = "czeka na połączenie",
    analysingTitle = "Odczytywanie dokumentu…",
    analysingSubtitle = "Wyodrębnianie dostaw może potrwać kilka sekund.",
    analysingSubtitlePdf = "Claude Haiku wyodrębnia dostawy — może to potrwać kilka sekund w przypadku zeskanowanego PDF-a.",
    stepFileSent = "Plik wysłany",
    stepExtracting = "Wyodrębnianie pól",
    stepReview = "Sprawdzenie przed dodaniem",
    successTitle = "Wykryto dostawę",
    successSubtitle = "Sprawdź informacje przed dodaniem ich do trasy.",
    addToRouteButton = "Dodaj do trasy",
    scanAnotherButton = "Zeskanuj inny dokument",
    partialTitle = "Prawie kompletne",
    partialSubtitle = "Jednego pola nie udało się odczytać z dokumentu.",
    missingFieldPlaceholder = "Do uzupełnienia…",
    partialBannerText = "Niektórych informacji nie udało się odczytać. Możesz zatwierdzić dane w takiej formie i uzupełnić je później, albo wysłać czytelniejszy dokument.",
    retryFileButton = "Wyślij inny plik",
    validateAndContinueButton = "Zatwierdź i kontynuuj",
    attemptLabel = "Próba",
    errorTitleUnreadable = "Nieczytelny dokument",
    errorTitleMissingFields = "Nie znaleziono informacji",
    errorTitleNetworkError = "Problem podczas analizy",
    errorTitleGeneric = "Analiza nie powiodła się",
    errorSubtitle = "Nie udało się wykryć dostawy w tym pliku.",
    errorBannerSuffixUnreadable = "obraz jest zbyt ciemny lub tekst jest przycięty. Zrób dobrze wykadrowane, dobrze oświetlone zdjęcie lub wyślij czytelniejszy plik.",
    errorBannerSuffixMissingFields = "nie znaleziono żadnych przydatnych informacji. Sprawdź zawartość pliku lub wyślij inny.",
    errorBannerSuffixNetworkError = "usługa analizy napotkała problem z siecią. Spróbuj ponownie za chwilę.",
    errorBannerSuffixGeneric = "podczas analizy wystąpił nieoczekiwany błąd. Spróbuj ponownie lub wyślij inny plik.",
    retryWithNewFileButton = "Spróbuj ponownie z innym plikiem",
    manualEntryButton = "Wprowadź ręcznie",
    attemptsRemainingNote = "Masz jeszcze 1 próbę dla tego dokumentu.",
    maxAttemptsTitle = "Wciąż nieczytelny",
    maxAttemptsSubtitle = "Nie udało się odczytać tego dokumentu po 2 próbach.",
    maxAttemptsBanner = "Osiągnięto limit prób dla tego dokumentu. Uzupełnij dostawę ręcznie lub zacznij import od nowa z nowym dokumentem.",
    retryUnavailableButton = "Spróbuj ponownie — niedostępne",
    newDocumentButton = "Zaimportuj nowy dokument",
    serviceUnavailableTitle = "Usługa tymczasowo niedostępna",
    serviceUnavailableSubtitle = "Automatyczna analiza nie odpowiada w tej chwili.",
    serviceUnavailableBanner = "Spróbuj ponownie za chwilę lub w tym czasie uzupełnij dostawę ręcznie.",
    offlineTitle = "Jesteś offline",
    offlineSubtitle = "Twój plik jest gotowy, ale nie został jeszcze wysłany.",
    offlineBanner = "Połącz się ponownie z internetem, a następnie uruchom analizę ponownie. Nic nie zostało wysłane do serwera — żadna próba nie została zliczona.",
    retryOfflineButton = "Spróbuj ponownie — brak połączenia",
    unsupportedFormatBanner = "Nieobsługiwany format pliku. Wybierz zdjęcie, plik PDF lub Excel/CSV.",
    validationTitle = "Sprawdź dostawy",
    fileRejectedTitle = "Plik nie został wysłany",
    fileRejectedSubtitle = "Wybierz inny plik, aby kontynuować.",
    bannerFileRequired = "nie wybrano żadnego pliku. Wybierz plik PDF, aby kontynuować.",
    bannerInvalidPdfFormat = "nieobsługiwany format. Tutaj akceptowane są tylko pliki PDF.",
    bannerFileTooLarge = "plik jest zbyt duży. Wybierz lżejszy plik PDF.",
    chooseAnotherFileButton = "Wybierz inny plik",
)
